import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { RootStateType } from "@Store";
import { IAuthRouteProps } from "@Interfaces";
import { useSelector } from "react-redux";

interface IPublicRouteProps extends IAuthRouteProps {
    isRestricted?: boolean;
}

export const PublicRoute = ({
    component: Component,
    isRestricted,
}: IPublicRouteProps) => {
    const isAuthenticated = useSelector(
        (state: RootStateType) => state.auth.isAuthenticated
    );
    const location = useLocation();

    if (isAuthenticated && isRestricted) {
        return (
            <Navigate
                to="/"
                replace
                state={{ from: location }} //if not auth go back to overview page
            />
        );
    }

    return <Component />;
};

export default PublicRoute;
